module.exports = __webpack_public_path__ + "translations/en/game.json";


//////////////////
// WEBPACK FOOTER
// ./translations/en/game.json
// module id = ./translations/en/game.json
// module chunks = 1